//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    background-color: #ECF4F9;
    padding: 24px;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
`;
export const Content = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 36px;
    width: 100%;
    margin: 0;
    padding: 0 30px 0 0;
    box-sizing: border-box;
    max-height: ${({ maxHeight = "348px" }) => maxHeight};
    overflow-y: scroll;
    &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: var(--light-gray-4);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    @media (max-width: 775px) {
        gap: 16px;
    }
`;
export const AboutSchedule = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    margin: 0;
    padding: 0 4px;
    min-height: 24px;
    & span {
        font-size: 14px;
        color: var(--light-gray-5);
    }
`;
export const ScheduleCard = styled.li`
    list-style: none;
    background-color: var(--light-1);
    border-radius: 8px;
    padding: 12px;
    min-height: 92px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
    & > div:first-child {
        min-height: 36px;
    }
`;
